"use client";

import { useState } from "react";
import { neueHeitz, tagada } from "../../../global-fonts";
import { SolidarityLatticeDiagram } from "./SolidarityLatticeDiagram";

const BULLET_ICON = "/images/swirly-sun-transparent-bg.png";

export default function SolidarityLatticeIntro() {

  return (
    <section
      className={`flex-col
      lg:flex flex-row
      bg-[url(/images/burgundy-textured-background.png)] `}
    >
      <div
        className={`
          lg:pt-32
          pb-12
          pt-16
                  pl-12
                  pr-12
                  pb-12
                  lg:pl-24
                  lg:pr-24
                  text-sky
          `}
      >
        <h2
          className={`${neueHeitz.className} 
                  text-fluid-md
                  md:text-fluid-lg
                  text-sand 
                  leading-none
                  pb-16`}
        >
          <div className={`${tagada.className}`}>We are building a</div>solidarity lattice
        </h2>
        <p
          className={`
            text-fluid-md
            md:text-fluid-base
            p-8
            rounded-[2rem]
            flex 
            text-fluid-md
            md:text-fluid-base 
            bg-burgundy`}
        >
          An alternative supply-chain that challenges the industrial grain complex. 
          Our supply-chain is unique because cultural story and empathy pulse at the core. 
        </p>
        <SolidarityLatticeDiagram />
        <div className={`
          p-8
          rounded-[2rem]
          text-center
          text-fluid-md
          md:text-fluid-base 
          bg-burgundy`}
        >
          <p>
            The Solidarity Lattice builds a common community purpose: 
            regeneratively flowing resources from public power, to our farmers and knowledge protectors, and back into protecting our soils, waters, and diverse seeds. Resource flow includes:
          </p>
          <ul className="py-4 [&_img]:-translate-y-[2px]">
            <li><img src={BULLET_ICON} alt="bullet" className="inline mr-2 h-6 w-6" />Narrative change</li>
            <li><img src={BULLET_ICON} alt="bullet" className="inline mr-2 h-6 w-6" />Community-partnered products</li> 
            <li><img src={BULLET_ICON} alt="bullet" className="inline mr-2 h-6 w-6" />Economic power</li> 
            <li><img src={BULLET_ICON} alt="bullet" className="inline mr-2 h-6 w-6" />Cultural celebration</li>
            <li><img src={BULLET_ICON} alt="bullet" className="inline mr-2 h-6 w-6" />Policy advocacy</li>
          </ul>
          <p>
            We are breaking barriers which blockade marginalized peoples from accessing culturally important, healthy foods. 
          </p>
        </div>
      </div>
    </section>
  );
}
